import { useMemo } from 'react'
import { DashBoardValue } from 'features/dashBoard/hooks'
import { DashBoardItemOption } from 'features/dashBoard/types'
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import { TargetListResult } from "interface/search/targetList"

export const ScatterPlotGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'xValue',
      type: 'value',
      label: 'X軸'
    },
    {
      id: 'yValue',
      type: 'value',
      label: 'Y軸',
      prefix: 'x '
    },
    {
      id: 'size',
      type: 'value',
      label: '大きさ',
      prefix: 'x ',
      nullable: true
    },
    {
      id: 'color',
      type: 'axis',
      label: '色',
      prefix: 'x ',
      nullable: true
    }
  ]
]
type useScatterPlotGraphOptionProps<T> = {
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const useScatterPlotGraphOption = <T,>({
  dashBoard: {
    configure,
    globalAxisKey
  },
  options,
  targetList
}: useScatterPlotGraphOptionProps<T>) => useMemo(
  () => ({
    configure, options, targetList,
		xValueDef: getValueDef(configure, options, 'xValue', targetList),
		yValueDef: getValueDef(configure, options, 'yValue', targetList),
		sizeDef: getValueDef(configure, options, 'size', targetList),
		colorDef: getAxisDef(configure, options, 'color', globalAxisKey, targetList)
}),
  [options, configure, globalAxisKey, targetList]
)
